import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getNotifications = ({ queryKey, pageParam }, params) => {
  // Fusionner pageParam dans params pour la pagination
  const mergedParams = {
    entity_type: params.entityType === 'all' ? null : params.entityType,
    is_archived: params.isArchived,
    active_only: params.activeOnly,
    is_read: params.isRead,
    page: pageParam, // Assurez-vous que l'API utilise 'page' ou l'adaptez à vos besoins.
  };

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${queryKey[0]}`, {
      params: mergedParams,
    })
    .then((res) => res.data);
};

export default getNotifications;
